import getters from './getters';

const state = {
    can: {
        campaigns: {
            see: [ 'maintainer', 'admin', 'supervisor', 'auditor', 'administrativeAuditor' ],
            add: [ 'maintainer', 'admin', 'administrativeAuditor' ],
            edit: [ 'maintainer', 'admin', 'administrativeAuditor' ],
            addMailTemplate: [ 'maintainer', 'admin' ],
            editMailTemplate: [ 'maintainer', 'admin' ],
            importContacts: [ 'maintainer', 'admin', 'administrativeAuditor' ],
            addSchedule: [ 'maintainer', 'admin' ]
        },
        script: {
            see: [ 'maintainer', 'admin', 'supervisor', 'auditor', 'administrativeAuditor' ],
            add: [ 'maintainer', 'admin' ],
            edit: [ 'maintainer', 'admin' ],
            delete: [ 'maintainer', 'admin' ],
            duplicate: [ 'maintainer', 'admin' ],
            preview: [ 'maintainer', 'admin' ]
        },
        clients: {
            see: [ 'maintainer', 'admin' ],
            add: [ 'any' ],
            edit: [ 'any' ]
        },
        users: {
            see: [ 'maintainer', 'admin', 'supervisor' ],
            add: [ 'maintainer', 'admin' ],
            edit: [ 'maintainer', 'admin' ],
            delete: [ 'maintainer', 'admin' ]
        },
        audit: {
            see: [ 'any' ],
            add: [ 'maintainer', 'admin', 'supervisor' ],
            addContact: [ 'maintainer', 'admin', 'supervisor' ],
            edit: [ 'none' ],
            manualContact: [ 'maintainer', 'admin', 'supervisor', 'operator' ],
            prioritize: [ 'maintainer', 'admin', 'supervisor' ],
            resolve: [ 'maintainer', 'admin', 'supervisor' ],
            updateContact: [ 'maintainer', 'admin', 'supervisor' ],
            seeTotals: [ 'maintainer', 'admin', 'supervisor', 'auditor', 'administrativeAuditor' ]
        },
        reporting: {
            see: [ 'any' ],
            add: [ 'none' ],
            dailyReporting: [ 'maintainer', 'admin', 'supervisor' ],
            monthlyReporting: [ 'maintainer', 'admin', 'supervisor', 'auditor', 'administrativeAuditor' ]
        },
        profile: {
            see: [ 'any' ],
            add: [ 'none' ],
            edit: [ 'none' ]
        },
        operate: {
            do: [ 'maintainer', 'admin', 'supervisor', 'operator' ],
            supervise: [ 'maintainer', 'admin', 'supervisor' ]
        }
    }
};

export default {
    state,
    getters
};